export const MAX_WEBSITE_VERSION = 48;
